import { useEffect } from "react";
import { Dropdown, Button, Space } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useAuthStore } from "../../stores/authStore";
import { useLogout, useWhoAmI } from "../../hooks/useAuth";
import { useAppStore } from "stores/appStore";
import GlobalSearch from "./GlobalSearch";
import QuickActions from "./QuickActions";

const Header = () => {
  const { user } = useAuthStore();
  const { headerTitle } = useAppStore();
  const logoutMutation = useLogout();
  const { data: currentUser } = useWhoAmI();

  // Block body is required: an implicit-return arrow here would return
  // window.scrollTo's return value as the effect's cleanup function. That
  // return value is normally undefined, but if something (extension/polyfill)
  // patches window.scrollTo to return a Promise, React calls it as destroy()
  // on unmount and throws "destroy is not a function".
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const handleLogout = async () => {
    try {
      await logoutMutation.mutateAsync();
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const displayUser = currentUser || user;
  const displayUsername = currentUser?.displayName;
  const displayRoles =
    displayUser?.roles?.join(", ") || displayUser?.role || "USER";

  const userMenuItems = [
    {
      key: "user-info",
      label: (
        <div className="user-dropdown-info">
          <div className="user-dropdown-name">{displayUsername}</div>
          <div className="user-dropdown-role">{displayRoles}</div>
        </div>
      ),
      disabled: true,
    },
    {
      key: "profile",
      label: "Profile",
      icon: <UserOutlined />,
      onClick: () => {},
    },
    {
      key: "logout",
      label: logoutMutation.isLoading ? "Logging out..." : "Logout",
      icon: <LogoutOutlined />,
      onClick: handleLogout,
      disabled: logoutMutation.isLoading,
    },
  ];

  return (
    <div className="page-header">
      <div className="header-layout">
        <div className="header-zone-title">
          <h1 className="page-title">{headerTitle}</h1>
        </div>
        <div className="header-zone-search">
          <GlobalSearch />
        </div>
        <div className="header-zone-actions">
          <QuickActions />
        </div>
        <div className="header-zone-user">
          <Dropdown
            menu={{ items: userMenuItems }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Button type="text" className="btn-user-menu">
              <Space size={8}>
                <UserOutlined className="user-avatar-icon" />
                <span className="user-display-name">{displayUsername}</span>
              </Space>
            </Button>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default Header;
